import { createFileRoute } from '@tanstack/react-router';
import { WizardStepRouter } from '@/domains/sales/wizard/WizardStepRouter';

// Un solo route dinámico para los pasos → URLs /wizard/s/:id/otp, /kyc, /product, … (spec F2).
// El dispatcher (WizardStepRouter) elige el componente de paso por slug.
export const Route = createFileRoute('/wizard/s/$sessionId/$step')({
    component: StepRoute,
});

function StepRoute() {
    const { sessionId, step } = Route.useParams();
    return <WizardStepRouter sessionId={sessionId} slug={step} />;
}
